<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <BomCar v-if='selectedIndex === 0'/>
    <BomProductTree v-if='selectedIndex === 1'/>
    <!-- <BomSemiProduct v-if='selectedIndex === 2'/>
    <BomProcessed v-if='selectedIndex === 3'/> -->
    <BomBatchReg v-if='selectedIndex === 2'/>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxTabPanel from 'devextreme-vue/tab-panel'
import BomProductTree from './BomProductTree'
import BomCar from './BomCar'
// import BomProcessed from './BomProcessed'
// import BomSemiProduct from './BomSemiProduct'
import BomBatchReg from './BomBatchReg'
import HttpService from '../../share/service/HttpService'

export default {
  name: 'bom-tab',
  data: function () {
    return {
      selectedIndex: 0,
      tabs: []
    }
  },
  components: {
    DxTabPanel,
    BomProductTree,
    BomCar,
    // BomSemiProduct,
    // BomProcessed,
    BomBatchReg
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    let user = this.$store.getters.getUserInfo
    console.log(user)
    if (user === undefined || user === null) {
      this.$router.push('/')
    }
    const topMenuTab = this.$store.getters.getTopMenuTabByUrl(this.$route.path)
    if (topMenuTab !== null) {
      const tabNameArray = topMenuTab.multiTabName.split('/')
      for (let i = 0; i < tabNameArray.length; i++) {
        let temp = {}
        temp.title = tabNameArray[i]
        this.tabs.push(temp)
      }
    }
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {
    HttpService.reqPost({}, '/forwardBomAll')
  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
